import { FieldNode, TextField } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

export default function getTextFelidSuggestions(
  currentField: TextField | null,
  fields: DeepReadonly<FieldNode[]>
): string[] {
  const currentValue = currentField?.input?.value.toLowerCase();

  if (!currentField || !currentValue) {
    return [];
  }

  return Array.from(
    new Set(
      fields
        .filter((field) => field.participantReference.id === currentField.participantReference.id)
        .filter((field) => field.id !== currentField.id)
        .filter((field): field is TextField => field?.type === 'TEXT')
        .map((field) => field.input?.value.trim())
    )
  )
    .filter((value): value is string => !!value)
    .filter((value) => value.toLowerCase().startsWith(currentValue))
    .sort((a, b) => a.length - b.length)
    .slice(0, 5);
}
